import React from "react";
import { Routes, Route } from "react-router-dom";
import { CartPage, DashboardPage, HomePage, ProductsList , ProductDetail } from "../pages";
import  CompletePage  from "../pages/Cart/components/CompletePage";
import PrivacyPolicy from "../components/Other/PrivacyPolicy";
export const AllRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsList />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/complete" element={<CompletePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
};
